import {Dimensions, StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {grey80, white} from '/theme/color/on.color';
import {kimberlyLighter} from '/theme/color/secondary.color';
const height = Dimensions.get('window').height;

export const styles = StyleSheet.create({
  base: {},
  modal: {
    backgroundColor: grey80,
    width: '100%',
    margin: 0,
  },
  modalView: {
    height: height > 684 ? '30%' : '60%',
    backgroundColor: white,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
  },
  modalHeader: {
    flexDirection: 'row',
    padding: 10,
    marginTop: 10,
  },
  modalBody: {
    flexDirection: 'column',
    padding: 10,
    margin: 10,
    marginLeft: 30,
  },
  headerText: {
    fontSize: 14,
    fontWeight: '600',
    marginBottom: 10,
  },
  bodyText: {
    fontSize: 14,
    fontWeight: '400',
  },
  modalFooter: {
    flexDirection: 'column',
  },

  buttonBox: {
    justifyContent: 'center',
    borderWidth: 1,
    borderColor: kimberlyLighter,
    width: '80%',
    marginLeft: indent * 2,
    borderRadius: indent * 0.4,
    marginBottom: indent * 1,
    height: 40,
  },
});
